export default __webpack_public_path__ + "media/images/Masto-K2-tolérance-102f55c05009dbc6453876f02ab7f531.png";